import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton } from "@mui/material";
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
// components
import { MHidden } from "../../components/@material-extend";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import NotificationBar from "../../components/NotificationBar";
import ToggleDark from "./ToggleDark";
import UpgradePopup from "./UpgradePopup";
import { CheckPerm } from "../../utils/apis";
import SyncData from "./SyncData";
import { useSelector } from "../../redux/store";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
  switchGenerate: PropTypes.bool,
  setSwitchGenerate: PropTypes.func,
};

export default function DashboardNavbar({
  onOpenSidebar,
  switchGenerate,
  setSwitchGenerate,
}) {
  const { isCollapse } = useCollapseDrawer();
  const hasPermission = CheckPerm("view_and_receive_notifications");
  const hasSubPermission = CheckPerm("view_subscription_and_billing");
  const { isOnline } = useSelector((state) => state.offline);

  return (
    <RootStyle
      sx={{
        displayPrint: "none",
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` },
        }),
      }}
    >
      <NotificationBar />
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <ToggleDark />
          <SyncData
            switchGenerate={switchGenerate}
            setSwitchGenerate={setSwitchGenerate}
          />
          {hasSubPermission && isOnline && (
            <MHidden width="lgDown">
              <UpgradePopup />
            </MHidden>
          )}
          {hasPermission && isOnline && <NotificationsPopover />}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
